import React, {Component} from 'react';

import services from './../../services';

import layouts from './../../layouts';
import Modal from './../Modal';
import Grid from './../Grid';
import Submit from './../Submit';

import { Modal as antdModal } from 'antd';
import components from './../../components';
import SelectInput from './../../components/selectinput';

export default class extends Component {
    constructor(props) {
        super(props);

        this.state = {
            roleId: undefined,
            classesList:[],
            classesData: [],
            keywords: {},
        };


        services.studentRole.studentModal.onSelect([]);
    }

    componentWillReceiveProps(nextProps) {
        const roleId = nextProps.roleId;
        this.setState({
            keywords: {
                v: Math.random(),
                pageNum: 1,
                orgId: '', 
                classesId: '', 
                classesName: '',
                studentNo: '',
            },
            roleId
        })
    }

    handleSubmit() {
        const studentIds = services.studentRole.studentModal.getSelection();
        if (!studentIds || studentIds.length === 0) {
            antdModal.warn({
                title: '请选择学生记录',
                content: '请选择学生记录'
            })
            return;
        }
        const data = {
            roleId: this.state.roleId,
            studentIds
        }
        services.roles.saveRoleStudent(data).then(d => {
            this.handleCancel();
        });
    }

    handleChange(data) {
        this.setState({
            keywords: Object.assign({}, this.state.keywords, data)
        });
    }

    handleSearchSubmit() {
        this.setState({
            keywords: Object.assign({}, this.state.keywords, {
                v: Date.now(),
                pageNum: 1
            })
        });
    }
    
    handleCancel() {
        this.props.handleCancel();
        this.setState({
            keywords: {v: Date.now(), visible: this.props.visible, orgId: '', classesId: '',classesName:'', studentNo: ''},
        })
    }

    querySearchByClasses(value) {
        var params = {
            classesName: value,
            orgId: this.state.keywords.orgId,
            // employeeId: this.state.keywords.employeeId,
            limitFlag: true
        };

        return services.classes.querySearchByName(params)
        .then((data) => {
            return data.map(item => {
                return {
                    value: item.value,
                    key: item.value,
                    label: item.label
                }
            }).slice(0,50);
        }).then(classesData => {
            this.setState({
                classesData
            })
        });
    }

    render() {
        return (
            <Modal 
                title={'添加组成员'} 
                styleName={'root-modal root-role-student-modal'}
                visible={this.props.visible}
                width={"1100px"}
                okText='确定'
                handleSubmit={this.handleSubmit.bind(this)}
                handleCancel={this.handleCancel.bind(this)}
            >
                <layouts.Search onSubmit={this.handleSearchSubmit.bind(this)}>
                    <div>
                        <div className="search-item">
                            <components.org.Name type="all" value={this.state.keywords.orgName} style={{width: 160}} handleChange={this.handleChange.bind(this)} />
                            <SelectInput 
                                name="classesId"
                                value={this.state.keywords.classesName}
                                search={true}
                                style={{width: 160}}
                                onChange={(data) => {
                                    this.handleChange({
                                        classesId: data.key,
                                        classesName: data.label
                                    })
                                }} 
                                onSearch={(value) => {
                                    this.querySearchByClasses(value);
                                }} 
                                onFocus={(target) => {
                                    if(this.state.keywords.orgId) {
                                        this.querySearchByClasses('');
                                    } else {
                                        if(target) {
                                            target.blur();
                                        }
                                        antdModal.error({
                                            title: '请先选择部门',
                                            content: (
                                                <div>
                                                <p>只有请先选择部门后才能后续操作！</p>
                                                </div>
                                            ),
                                            onOk() {},
                                        });
                                    }
                                }}
                                label="班级"
                                data={this.state.classesData} 
                            />        
                            <components.student.StudentNo value={this.state.keywords.studentNo} style={{width: 160}} handleChange={this.handleChange.bind(this)} />
                            <Submit>检索</Submit>
                        </div>
                    </div>
                </layouts.Search>
                <Grid ismodal="true" keywords={this.state.keywords} service={services.studentRole.studentModal}/>
            </Modal>
        )
    }
}